import { Outlet } from "react-router";
import { useAuthContext } from "@/contexts/AuthProvider";
import { LoadingIndicator } from "./ui/loading-indicator";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { keycloak } from "@/libs/keycloak";
import { Layout } from "./Layout";

function AuthGuard() {
  const { isLoading, user } = useAuthContext();

  if (isLoading) {
    return (
      <div className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 grid place-items-center gap-2">
        <LoadingIndicator variant="bars" className="size-16" />
        <p className="animate-pulse text-xl font-semibold tracking-tight">
          Authenticating...
        </p>
      </div>
    );
  }

  if (!isLoading && !user) {
    return (
      <Card className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-center shadow-lg w-full max-w-md gap-4">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Access Denied</CardTitle>
        </CardHeader>

        <CardContent className="space-y-6">
          <p className="text-sm text-muted-foreground">
            You are not authorized to access this application. Please sign in
            with an account that has the necessary permissions.
          </p>

          <Button
            onClick={() => keycloak.logout()}
            className="cursor-pointer w-full"
          >
            Go to Login
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export { AuthGuard };
